// hooks/usePWAKeyboardHandler.js
import { useEffect } from 'react';

// Custom hook for handling PWA keyboard behavior
export const usePWAKeyboardHandler = () => {
  useEffect(() => {
    let initialViewportHeight = window.innerHeight;
    let currentViewportHeight = window.innerHeight;
    
    const handleViewportChange = () => {
      currentViewportHeight = window.innerHeight;
      const heightDifference = initialViewportHeight - currentViewportHeight;
      const keyboardVisible = heightDifference > 150; // Threshold for keyboard detection
      
      const bottomNav = document.querySelector('.bottom-nav');
      const bottomNavSpacer = document.querySelector('.bottom-nav-spacer');
      const appPage = document.querySelector('.app-page');
      
      if (keyboardVisible) {
        // Keyboard is visible
        if (bottomNav) {
          bottomNav.style.transform = 'translateY(100%)';
          bottomNav.style.opacity = '0';
          bottomNav.style.pointerEvents = 'none';
        }
        if (bottomNavSpacer) {
          bottomNavSpacer.style.height = '0px';
        }
        if (appPage) {
          appPage.style.paddingBottom = '0px';
        }
        
        // Add keyboard-visible class to body
        document.body.classList.add('keyboard-visible');
      } else {
        // Keyboard is hidden
        if (bottomNav) {
          bottomNav.style.transform = 'translateY(0)';
          bottomNav.style.opacity = '1';
          bottomNav.style.pointerEvents = 'auto';
        }
        if (bottomNavSpacer) {
          bottomNavSpacer.style.height = '60px';
        }
        if (appPage) {
          appPage.style.paddingBottom = '';
        }
        
        // Remove keyboard-visible class from body
        document.body.classList.remove('keyboard-visible');
      }
    };

    // Visual Viewport API support (better than resize)
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleViewportChange);
      window.visualViewport.addEventListener('scroll', handleViewportChange);
    } else {
      // Fallback to window resize
      window.addEventListener('resize', handleViewportChange);
    }

    // Handle input focus/blur for additional control
    const handleInputFocus = (e) => {
      if (e.target.matches('input, textarea, select')) {
        setTimeout(() => {
          const bottomNav = document.querySelector('.bottom-nav');
          if (bottomNav && window.innerHeight < initialViewportHeight - 100) {
            bottomNav.style.transform = 'translateY(100%)';
            bottomNav.style.opacity = '0';
          }
        }, 300); // Delay to let keyboard animate
      }
    };

    const handleInputBlur = (e) => {
      if (e.target.matches('input, textarea, select')) {
        setTimeout(() => {
          const bottomNav = document.querySelector('.bottom-nav');
          if (bottomNav) {
            bottomNav.style.transform = 'translateY(0)';
            bottomNav.style.opacity = '1';
          }
        }, 100);
      }
    };

    document.addEventListener('focusin', handleInputFocus);
    document.addEventListener('focusout', handleInputBlur);

    // Cleanup
    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', handleViewportChange);
        window.visualViewport.removeEventListener('scroll', handleViewportChange);
      } else {
        window.removeEventListener('resize', handleViewportChange);
      }
      document.removeEventListener('focusin', handleInputFocus);
      document.removeEventListener('focusout', handleInputBlur);
      
      // Reset styles
      const bottomNav = document.querySelector('.bottom-nav');
      const bottomNavSpacer = document.querySelector('.bottom-nav-spacer');
      if (bottomNav) {
        bottomNav.style.transform = '';
        bottomNav.style.opacity = '';
        bottomNav.style.pointerEvents = '';
      }
      if (bottomNavSpacer) {
        bottomNavSpacer.style.height = '';
      }
      document.body.classList.remove('keyboard-visible');
    };
  }, []);
};

export default usePWAKeyboardHandler;